import { Option } from 'owa-options-core';
import * as React from 'react';
import SenderSubjectFull from './components/SenderSubjectFull';
import discardSenderSubjectOption from './actions/discardSenderSubjectOption';
import saveSenderSubjectOption from './actions/saveSenderSubjectOption';
import isSenderSubjectOptionDirty from './utils/isSenderSubjectOptionDirty';

let SenderSubjectOption: Option = {
    key: 'senderSubject',
    titleStringKey: 'optionTitle_senderSubjectOrder',
    searchTermsStringKey: 'optionTitle_senderSubjectOrder',
    fullOptionFormSettings: {
        render: () => <SenderSubjectFull />,
        isDirty: isSenderSubjectOptionDirty,
        onSave: saveSenderSubjectOption,
        onDiscard: discardSenderSubjectOption,
    },
};

export default SenderSubjectOption;
